import { UseGetProductResponse } from "types/queries";

import { trackPdcEvent } from "./track-pdc-event";

export const trackFormSubmitEvent = (
  product: UseGetProductResponse,
  formTrackingId: string,
  step: string | number,
  subStep: string | number
) => {
  trackPdcEvent(product, formTrackingId, "submit", step, subStep);
};
